document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('variant-selects').forEach(variantSelects => {
    const genderInputs = variantSelects.querySelectorAll('input[name="Gender"]');
    if (!genderInputs.length) return;

    const getVariantData = () => {
      const json = variantSelects.querySelector('[type="application/json"]');
      return json ? JSON.parse(json.textContent) : [];
    };

    genderInputs.forEach(input => {
      input.addEventListener('change', () => {
        const selectedGender = input.value;
        const variantData = getVariantData();

        const checkedSize = variantSelects.querySelector('input[name="Size"]:checked');
        const currentSize = checkedSize ? checkedSize.value : null;

        // Prefer same size for new gender, fallback to first available
        const match =
          variantData.find(v => v.option1 === selectedGender && v.option2 === currentSize && v.available) ||
          variantData.find(v => v.option1 === selectedGender && v.available);

        if (!match) return;

        const sizeInput = variantSelects.querySelector(`input[name="Size"][value="${match.option2}"]`);
        if (sizeInput && !sizeInput.checked) {
          sizeInput.checked = true;
          sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });
});